"use client";

import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

const firebaseClientApp = !getApps().length ? initializeApp(firebaseConfig) : getApp();

const firebaseClientAuth = getAuth(firebaseClientApp);

let _db;
function getFirestoreDb() {
    if (!_db) {
        _db = getFirestore(firebaseClientApp);
    }
    return _db;
}

let _storage;
function getStorageDb() {
    if (!_storage) {
        _storage = getStorage(firebaseClientApp);
    }
    return _storage;
}

export {
    firebaseClientApp,
    firebaseClientAuth,
    getFirestoreDb,
    getStorageDb
};
